var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm16 md16" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: _vm.formFields.simnumero.label },
                            model: {
                              value: _vm.formFields.simnumero.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.simnumero, "value", $$v)
                              },
                              expression: "formFields.simnumero.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.motibaja.label,
                              items: _vm.bajalist,
                              "item-text": "motiname",
                              "item-value": "motiid",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.motibaja.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.motibaja, "value", $$v)
                              },
                              expression: "formFields.motibaja.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaInicio.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaInicio.id
                              ),
                              id: _vm.formFields.fechaInicio.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaInicio.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaInicio,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.fechaInicio.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaFin.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaFin.id
                              ),
                              id: _vm.formFields.fechaFin.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaFin.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                              },
                              expression: "formFields.fechaFin.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _vm.accionCrear.visible
                              ? _c(
                                  "v-btn",
                                  {
                                    staticStyle: { "padding-right": "20px" },
                                    attrs: { color: "#ffe800" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleCrearClick()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticStyle: { color: "black" },
                                        attrs: { dark: "", left: "" }
                                      },
                                      [_vm._v("add_circle_outline")]
                                    ),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "black" } },
                                      [_vm._v("Crear")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            staticClass: "solicitud-baja",
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c("CrearSolicitud", {
        attrs: {
          modoVer: true,
          show: _vm.mostrarModalCrear,
          serverSide: _vm.serverSide
        },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalVerDetalle,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.$t("¿Está seguro de anular la solicitud?"),
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event, _vm.params)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }